/**
 * Environment Configuration
 * 
 * ONLY uses environment variables from Emergent deployment page
 * NO fallbacks, NO auto-detection, NO hardcoded values
 */

/**
 * Get the backend API URL - ONLY from deployment environment variables
 */
export const getBackendUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  
  // Log the environment variable for debugging
  console.log('[Config] REACT_APP_BACKEND_URL from deployment env:', envUrl);
  
  // MUST use deployment environment variable - no fallbacks
  if (!envUrl || envUrl.trim() === '') {
    console.error('[Config] ❌ CRITICAL: REACT_APP_BACKEND_URL not set on deployment page!');
    console.error('[Config] ❌ Please set REACT_APP_BACKEND_URL=https://www.thehautecircle.com on deployment page');
    throw new Error('REACT_APP_BACKEND_URL environment variable is required but not set on deployment page');
  }
  
  console.log('[Config] ✅ Using backend URL from deployment environment variable:', envUrl);
  return envUrl;
};

/**
 * Get the local admin backend API URL - ONLY from deployment environment variables
 */
export const getLocalAdminBackendUrl = () => {
  const envUrl = process.env.REACT_APP_LOCAL_ADMIN_BACKEND_URL;
  
  // Log the environment variable for debugging
  console.log('[Config] REACT_APP_LOCAL_ADMIN_BACKEND_URL from deployment env:', envUrl);
  
  // MUST use deployment environment variable - no fallbacks
  if (!envUrl || envUrl.trim() === '') {
    console.error('[Config] ❌ CRITICAL: REACT_APP_LOCAL_ADMIN_BACKEND_URL not set on deployment page!');
    console.error('[Config] ❌ Please set REACT_APP_LOCAL_ADMIN_BACKEND_URL=https://www.admin.thehautecircle.com on deployment page');
    throw new Error('REACT_APP_LOCAL_ADMIN_BACKEND_URL environment variable is required but not set on deployment page');
  }
  
  console.log('[Config] ✅ Using local admin backend URL from deployment environment variable:', envUrl);
  return envUrl;
};

/**
 * Get the local admin URL - ONLY from deployment environment variables
 */
export const getLocalAdminUrl = () => {
  const envUrl = process.env.REACT_APP_LOCAL_ADMIN_URL;
  
  // Log the environment variable for debugging
  console.log('[Config] REACT_APP_LOCAL_ADMIN_URL from deployment env:', envUrl);
  
  // MUST use deployment environment variable - no fallbacks
  if (!envUrl || envUrl.trim() === '') {
    console.error('[Config] ❌ CRITICAL: REACT_APP_LOCAL_ADMIN_URL not set on deployment page!');
    console.error('[Config] ❌ Please set REACT_APP_LOCAL_ADMIN_URL=https://www.admin.thehautecircle.com on deployment page');
    throw new Error('REACT_APP_LOCAL_ADMIN_URL environment variable is required but not set on deployment page');
  }
  
  console.log('[Config] ✅ Using local admin URL from deployment environment variable:', envUrl);
  return envUrl;
};

/**
 * Configuration object - ONLY uses deployment environment variables
 */
const config = {
  // Backend API URL - from deployment page ONLY
  backendUrl: getBackendUrl(),
  
  // Local Admin Backend URL - from deployment page ONLY
  localAdminBackendUrl: getLocalAdminBackendUrl(),
  
  // Local Admin URL - from deployment page ONLY
  localAdminUrl: getLocalAdminUrl(),
  
  // Other config
  environment: process.env.NODE_ENV || 'development',
  
  // Log the configuration on load
  logConfig: () => {
    console.log('='.repeat(80));
    console.log('[Config] ✅ DEPLOYMENT ENVIRONMENT VARIABLES ONLY - NO FALLBACKS');
    console.log('[Config] Business Backend API URL (REACT_APP_BACKEND_URL):', config.backendUrl);
    console.log('[Config] Local Admin Backend API URL (REACT_APP_LOCAL_ADMIN_BACKEND_URL):', config.localAdminBackendUrl);
    console.log('[Config] Local Admin URL (REACT_APP_LOCAL_ADMIN_URL):', config.localAdminUrl);
    console.log('[Config] Environment:', config.environment);
    console.log('[Config] ✅ All URLs sourced from Emergent deployment page environment variables');
    console.log('='.repeat(80));
  }
};

// Log configuration on module load
config.logConfig();

export default config;
